import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { ProjectList } from "./constants";
import Header from "./components/header";
import AllProjects from "./pages/allProjects";
import Prime from "./Prime";
import Footer from "./components/footer";
import Contact from "./pages/contact";
import ScrollBarBtn from "./components/scrollBar/ScrollBarBtn";
function App() {
  const [theme, setTheme] = useState(null);
  const projectList = ProjectList;
  useEffect(() => {
    // ============ Keeping theme as dark by default ================
    setTheme("dark");
    // ============ System default theme start here =================
    // if (window.matchMedia("(prefers-color-scheme: dark").matches) {
    //   setTheme("dark");
    // } else {
    //   setTheme("light");
    // }
    // ============ System default theme end here ===================
  }, []);
  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [theme]);

  const themeChanger = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };
  return (
    <div
      className={`${
        theme === "dark" ? "bg-darkBgColor" : "bg-lightBgColor"
      } w-full h-auto font-bodyFont`}
    >
      <Header theme={theme} themeChanger={themeChanger} />
      <Routes>
        <Route path="/" element={<Prime theme={theme} />}></Route>
        <Route
          path="/projects"
          element={<AllProjects theme={theme} projectList={projectList} />}
        ></Route>
        <Route path="/contact" element={<Contact theme={theme} />}></Route>
      </Routes>
      <Footer theme={theme} />
      <div className="fixed top-[90vh] right-6">
        <ScrollBarBtn />
      </div>
    </div>
  );
}

export default App;
